import Cookies from 'js-cookie';

declare global {
  interface Window {
    fbq?: Function;
    _fbq?: Function;
  }
}

const CONSENT_COOKIE = 'ipos-cookies';
const FB_PIXEL_ID = '774820072621293';

type ConsentState = 'granted' | 'denied';

export const hasCookieConsent = (): boolean => !!Cookies.get(CONSENT_COOKIE);

// GTM only recognises consent commands pushed as a real `arguments` object.
function gtag(): void {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const pushConsent = (command: 'default' | 'update', state: ConsentState): void => {
  window.dataLayer = window.dataLayer || [];
  /* eslint-disable @typescript-eslint/camelcase */
  (gtag as Function)('consent', command, {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
    functionality_storage: state,
    personalization_storage: state,
    security_storage: 'granted',
  });
  /* eslint-enable @typescript-eslint/camelcase */
};

export const loadFacebookPixel = (): void => {
  if (process.env.IPOS_ENV !== 'production' || window.fbq) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fbq: any = (...args: unknown[]) =>
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args);
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  window._fbq = window._fbq || fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  fbq('init', FB_PIXEL_ID);
  fbq('track', 'PageView');
};

export const grantConsent = (): void => {
  pushConsent('update', 'granted');
  loadFacebookPixel();
};
